import { Outlet, useLocation } from 'react-router-dom';

import Sidebar from './Sidebar';
import UserMenu from './UserMenu';
import NotificationBell from './NotificationBell';
import GlobalSearch from './GlobalSearch';
import ErrorBoundary from './shared/ErrorBoundary';
import { ToastViewport } from './shared/Toast';
import { formatDate } from '@/lib/date';

const TITLES: Record<string, string> = {
  '/dashboard': 'Tableau de bord',
  '/profile': 'Mon profil',
  '/personnel': 'Personnel',
  '/personnel/new': 'Ajouter un employé',
  '/clients': 'Clients & contrats',
  '/clients/new': 'Ajouter un client',
  '/demandes': "Demandes d'employé",
  '/devis': 'Devis & tarifs',
  '/devis/new': 'Créer un devis',
  '/contrats/a-signer': 'À signer (Harmaury)',
  '/tarifs': 'Devis & tarifs',
  '/remplacements': 'Remplacements',
  '/missions': 'Missions',
  '/factures': 'Facturation',
  '/paie': 'Paie',
  '/pointages': 'Pointages',
  '/signalements': 'Signalements',
  '/carte': 'Carte des pointages',
  '/assurance': 'Assurance',
  '/cnps': 'CNPS',
  '/qualite': 'Qualité',
  '/evaluations': 'Notation & primes',
  '/config': 'Configuration',
  '/config/utilisateurs': 'Utilisateurs & rôles',
};

function resolveTitle(pathname: string): string {
  const exact = TITLES[pathname];
  if (exact !== undefined) {
    return exact;
  }
  if (pathname.startsWith('/personnel/')) {
    return 'Fiche personnel';
  }
  if (pathname.startsWith('/clients/')) {
    return 'Fiche client';
  }
  return 'Console Admin';
}

export default function AdminLayout(): JSX.Element {
  const location = useLocation();
  const title = resolveTitle(location.pathname);
  const today = formatDate(new Date());

  return (
    <div className="flex min-h-screen bg-pearl">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex h-16 items-center justify-between border-b border-line bg-white px-6">
          <div>
            <h1 className="font-display text-base font-extrabold text-navy-700">{title}</h1>
            <p className="font-sans text-xs text-sub">{today} · Yaoundé</p>
          </div>
          <div className="flex items-center gap-3">
            <GlobalSearch />
            <NotificationBell />
            <UserMenu />
          </div>
        </header>
        <main className="flex-1 overflow-y-auto px-6 py-6">
          {/* Le boundary est remonté (key) à chaque navigation : le crash d'une
              page n'efface pas la sidebar/header, et changer de page le récupère. */}
          <ErrorBoundary key={location.pathname}>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
      <ToastViewport />
    </div>
  );
}
